module.exports = __webpack_public_path__ + "static/media/facebook-white.41ea6edb.svg";